import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=fb7862b6&scoped=true&"
import script from "./video-detail.vue?vue&type=script&lang=js&"
export * from "./video-detail.vue?vue&type=script&lang=js&"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=fb7862b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7862b6",
  null
  
)

export default component.exports